/* eslint-disable react/prop-types */
import React from 'react';
import { Table } from 'antd';
import { formatCount, operatorColor, statusTheme } from '../utils/theme';
import { rowsByOperator } from '../utils/groupByOperator';
import styles from '../styles/Dashboard.module.css';

const columns = [
    {
        title: 'Operador',
        dataIndex: 'mnoProviderName',
        key: 'mnoProviderName',
        render: (name) => (
            <span className={styles.tableOperator}>
                <span className={styles.swatch} style={{ background: operatorColor(name) }} />
                {name}
            </span>
        ),
    },
    {
        title: 'Estado',
        dataIndex: 'status',
        key: 'status',
        // El color va en el punto; el texto queda en tinta para que se lea igual
        // en todos los estados (el ámbar de Pendiente no aguanta como texto).
        render: (status) => {
            const theme = statusTheme(status);
            return (
                <span className={styles.statusCell}>
                    <span className={styles.swatch} style={{ background: theme.color }} />
                    {theme.label}
                </span>
            );
        },
    },
    { title: 'Total', dataIndex: 'total', key: 'total', align: 'right', render: formatCount },
    { title: 'Apio', dataIndex: 'apio', key: 'apio', align: 'right', render: formatCount },
    { title: 'Stripe', dataIndex: 'stripe', key: 'stripe', align: 'right', render: formatCount },
    { title: 'Sin cobro', dataIndex: 'ninguno', key: 'ninguno', align: 'right', render: formatCount },
];

export default function StatusOverviewTable({ rows, loading }) {
    const data = rowsByOperator(rows);

    return (
        <Table
            columns={columns}
            dataSource={data.map((row, index) => ({
                ...row,
                key: `${row.mnoProviderName}-${row.status}-${index}`,
            }))}
            loading={loading}
            pagination={false}
            size="middle"
            className={styles.table}
            summary={(pageData) => {
                const totals = pageData.reduce(
                    (acc, row) => ({
                        total: acc.total + row.total,
                        apio: acc.apio + row.apio,
                        stripe: acc.stripe + row.stripe,
                        ninguno: acc.ninguno + row.ninguno,
                    }),
                    { total: 0, apio: 0, stripe: 0, ninguno: 0 }
                );
                return (
                    <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2}>
                            Total
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2} align="right">
                            {formatCount(totals.total)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3} align="right">
                            {formatCount(totals.apio)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={4} align="right">
                            {formatCount(totals.stripe)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={5} align="right">
                            {formatCount(totals.ninguno)}
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                );
            }}
        />
    );
}
